import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import PeopleController from "@/modules/people/PeopleController";
import { useHasAnyPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

const breadcrumbs = [{ label: "People", current: true }];

export default function People() {
  const canViewPeople = useHasAnyPermission(
    Permission.PEOPLE_VIEW_ALL,
    Permission.PEOPLE_VIEW_OWN,
  );

  if (!canViewPeople) {
    return (
      <AccessRestricted
        breadcrumbs={breadcrumbs}
        message="You do not have access to view people."
      />
    );
  }

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <PeopleController />
    </Layout>
  );
}
